import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  // Close on Escape
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    // Lock body scroll while open
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = original;
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-167">
      {isOpen && <motion.div className="fixed inset-0 z-[100] flex items-center justify-center px-4 py-8" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.25
    }} role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-168">
          {/* Backdrop */}
          <motion.div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} data-id="element-169" />

          {/* Modal */}
          <motion.div className="relative w-full max-w-2xl max-h-[85vh] bg-[#0d0d0d] border border-glass-border rounded-sm shadow-[0_30px_80px_rgba(0,0,0,0.6)] overflow-hidden flex flex-col" initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.97
      }} transition={{
        duration: 0.35,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-170">
            {/* Crimson accent line */}
            <div className="h-[2px] w-full bg-gradient-to-r from-transparent via-crimson to-transparent" data-id="element-171" />

            {/* Header */}
            <div className="flex items-start justify-between px-6 lg:px-10 pt-7 pb-5 border-b border-glass-border" data-id="element-172">
              <div data-id="element-173">
                <div className="text-[9px] tracking-[5px] uppercase text-gold-light font-light mb-2" data-id="element-174">
                  Elias Navarro Law
                </div>
                <h2 id="legal-modal-title" className="font-serif text-2xl lg:text-3xl font-bold text-white tracking-[-0.5px]" data-id="element-175">
                  {title}
                </h2>
              </div>
              <button onClick={onClose} aria-label="Close" className="text-[#f5f5f5]/50 hover:text-white transition-colors duration-200 p-1.5 -mr-1.5 rounded-sm hover:bg-white/5" data-id="element-176">
                <X className="w-5 h-5" data-id="element-177" />
              </button>
            </div>

            {/* Body */}
            <div className="overflow-y-auto px-6 lg:px-10 py-6 text-[13px] leading-[1.8] text-[#f5f5f5]/70 font-light tracking-[0.3px] space-y-4" data-id="element-178">
              {children}
            </div>

            {/* Footer */}
            <div className="px-6 lg:px-10 py-4 border-t border-glass-border flex justify-end" data-id="element-179">
              <button onClick={onClose} className="bg-crimson text-white px-7 py-3 text-[10px] tracking-[3px] uppercase font-bold rounded-sm transition-all duration-300 hover:bg-crimson-glow hover:-translate-y-[1px] hover:shadow-[0_8px_24px_rgba(192,57,43,0.4)]" data-id="element-180">
                Close
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}